import form from './form';

const wizardNav = { form };

export default wizardNav;
